import { useEffect, useRef } from 'react';

function createStar(windowWidth, windowHeight, speed) {
  return {
    x: (Math.random() * windowWidth - 0.5 * windowWidth) * speed,
    y: (Math.random() * windowHeight - 0.5 * windowHeight) * speed,
    z: speed,
    px: 0,
    py: 0,
  };
}

function HeaderAnimation() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvasElement = canvasRef.current;

    if (!canvasElement) {
      return undefined;
    }

    const context = canvasElement.getContext('2d');

    if (!context) {
      return undefined;
    }

    const frameUpdate =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;
    const cancelFrameUpdate =
      window.cancelAnimationFrame ||
      window.mozCancelAnimationFrame ||
      window.webkitCancelAnimationFrame ||
      window.msCancelAnimationFrame;

    let animationFrameId;
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
    const amount = 250;
    const applique = 0.04;
    const speed = 10;
    let stars = [];

    const resetCanvas = () => {
      windowWidth = window.innerWidth;
      windowHeight = window.innerHeight;
      canvasElement.width = windowWidth;
      canvasElement.height = windowHeight;
      context.globalAlpha = 0.33;
      stars = new Array(amount)
        .fill(null)
        .map(() => createStar(windowWidth, windowHeight, speed));
    };

    const drawFrame = () => {
      context.clearRect(0, 0, windowWidth, windowHeight);

      stars.forEach((star, index) => {
        const width = star.x / star.z;
        const height = star.y / star.z;

        if (star.px !== 0) {
          context.strokeStyle = '#FFF';
          context.lineWidth = 2;
          context.beginPath();
          context.moveTo(width + windowWidth / 2, height + windowHeight / 2);
          context.lineTo(star.px + windowWidth / 2, star.py + windowHeight / 2);
          context.stroke();
        }

        star.px = width;
        star.py = height;
        star.z -= applique;

        if (star.z < applique || star.px > windowWidth || star.py > windowHeight) {
          stars[index] = createStar(windowWidth, windowHeight, speed);
        }
      });

      animationFrameId = frameUpdate(drawFrame);
    };

    const handleResize = () => {
      resetCanvas();
    };

    resetCanvas();
    animationFrameId = frameUpdate(drawFrame);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);

      if (animationFrameId) {
        cancelFrameUpdate(animationFrameId);
      }
    };
  }, []);

  return <canvas id="header-animation" ref={canvasRef} />;
}

export default HeaderAnimation;
